<template>
  <div class="logo" :style="{ '--px': pixelSize + 'px' }">
    <div class="logo-word">
      <div
        v-for="(letter, li) in logoLetters"
        :key="li"
        class="letter"
        :class="{ narrow: letter.length === 24 }"
      >
        <span
          v-for="(pixel, pi) in letter"
          :key="pi"
          class="pixel"
          :class="{ on: pixel === 1 }"
          :style="pixel === 1 ? { animationDelay: (li * 0.09 + pi * 0.006) + 's' } : undefined"
        ></span>
      </div>
    </div>
    <div class="logo-sub">
      <span v-for="(char, i) in 'CONSULTING'" :key="i" :style="{ animationDelay: 0.6 + i * 0.04 + 's' }">
        {{ char }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Logo',
  props: {
    pixelSize: {
      type: Number,
      default: 14,
    },
  },
  data() {
    return {
      logoLetters: [
        // D
        [1,1,1,0,0, 1,0,0,1,0, 1,0,0,1,0, 1,0,0,1,0, 1,0,0,1,0, 1,1,1,0,0],
        // E
        [1,1,1,1,0, 1,0,0,0,0, 1,1,1,0,0, 1,0,0,0,0, 1,0,0,0,0, 1,1,1,1,0],
        // V
        [1,0,0,0,1, 1,0,0,0,1, 1,0,0,0,1, 0,1,0,1,0, 0,1,0,1,0, 0,0,1,0,0],
        // 1
        [0,0,1,0, 0,1,1,0, 0,0,1,0, 0,0,1,0, 0,0,1,0, 0,1,1,1],
      ],
    };
  },
});
</script>

<style scoped>
.logo {
  display: inline-flex;
  flex-direction: column;
  gap: 0.6rem;
}

.logo-word {
  display: flex;
  gap: calc(var(--px) * 1.1);
}

.letter {
  display: grid;
  grid-template-columns: repeat(5, var(--px));
  gap: calc(var(--px) * 0.18);
}

.letter.narrow {
  grid-template-columns: repeat(4, var(--px));
}

.pixel {
  width: var(--px);
  height: var(--px);
  background: transparent;
}

.pixel.on {
  background: var(--nerv-orange);
  box-shadow: 0 0 calc(var(--px) * 0.7) rgba(255, 153, 0, 0.45);
  opacity: 0;
  animation: pixel-on 0.28s steps(2) forwards;
}

@keyframes pixel-on {
  0% { opacity: 0; }
  50% { opacity: 0.45; }
  100% { opacity: 1; }
}

.logo-sub {
  display: flex;
  justify-content: space-between;
  font-family: var(--font-nerv-display);
  font-size: calc(var(--px) * 0.72);
  font-weight: 600;
  letter-spacing: 0;
  color: var(--nerv-orange);
  opacity: 0.85;
}

.logo-sub span {
  opacity: 0;
  animation: pixel-on 0.3s steps(2) forwards;
}

@media (prefers-reduced-motion: reduce) {
  .pixel.on,
  .logo-sub span {
    opacity: 1;
    animation: none;
  }
}
</style>
